//Creates new CuvetteRack and assigns ID and type
export const createCuvetteRack = (data) => {
    //data = {id, type}
    return { type: "CREATE_CUVETTE_RACK", payload: data}
}
